<template>
    <div class="m-2">
        <div class="border-b border-gray-400 ml-2 mr-2 pb-2">
            <div class="text-gray-800">{{ $t('component.menu.applications') }}</div>
        </div>

        <div v-if="loading" class="flex justify-center ">
            <LoadingSpinner></LoadingSpinner>
        </div>
        <div v-else>
            <div class="mt-2">
                <div class="text-sm ml-3 mb-4 text-gray-800 font-bold">{{ $t('component.applications.accepted')}}</div>
                <div v-if="acceptedApplications.length === 0">
                    <div class="mt-5 mx-3 text-sm py-4 text-center">{{
                        $t('component.applications.noAcceptedApplications')}}
                    </div>
                </div>
                <div v-else>
                    <ApplicationItem v-for="application in acceptedApplications"
                                     :application="application.application"
                                     :mission="application.mission"
                                     :key="application.application_id">
                    </ApplicationItem>
                </div>
            </div>

            <div class="mt-10">
                <div class="text-sm ml-3 mb-4 text-gray-800 font-bold">{{ $t('component.applications.applied') }}</div>
                <div v-if="appliedApplications.length === 0">
                    <div class="mt-5 mx-3 text-sm py-4 text-center">{{
                        $t('component.applications.noAppliedApplications')}}
                    </div>
                    <ApplyButton/>
                </div>
                <div v-else>
                    <ApplicationItem v-for="application in appliedApplications"
                                     :application="application.application"
                                     :mission="application.mission"
                                     :key="application.application_id">
                    </ApplicationItem>
                    <ApplicationHint :numberAppliedApplications="appliedApplications.length"/>
                </div>

            </div>

            <div class="mt-10">
                <div class="text-sm ml-3 mb-4 text-gray-800 font-bold">{{ $t('component.applications.denied')}}</div>
                <div v-if="deniedApplications.length === 0">
                    <div class="mt-5 mx-3 text-sm py-4 text-center">{{
                        $t('component.applications.noDeniedApplications')}}
                    </div>
                </div>
                <div v-else>
                    <ApplicationItem v-for="application in deniedApplications"
                                     :application="application.application"
                                     :mission="application.mission"
                                     :key="application.application_id">
                    </ApplicationItem>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApplicationItem from "@/components/ApplicationItem";
    import LoadingSpinner from "@/components/LoadingSpinner";
    import ApplicationHint from "@/components/ApplicationHint";
    import ApplyButton from "@/components/shared/ApplyButton";
    import {mapState} from "vuex";

    export default {
        name: "Applications",
        components: {LoadingSpinner, ApplicationItem, ApplicationHint, ApplyButton},
        data() {
            return {
                loading: false,
                message: ''
            }
        },
        computed: {
            ...mapState('auth', {
                'applications': 'applications'
            }),
            filteredApplications() {
                let a = this.applications;
                const order = ['accepted', 'applied', 'denied'];
                a.sort((a, b) => order.indexOf(a.status) - order.indexOf(b.status))
                return a
            },
            appliedApplications() {
                return this.applications.filter(c => c.application.status === 'applied');
            },
            acceptedApplications() {
                return this.applications.filter(c => c.application.status === 'accepted');
            },
            deniedApplications() {
                return this.applications.filter(c => c.application.status === 'denied');
            },
        },
        async created() {
            this.loading = true;
            this.$store.dispatch('auth/applications').then(() => {
                this.loading = false;
                this.message = this.$t('component.applications.no_missions');
            }).catch(() => {
                this.message = this.$t('component.applications.error');
            });
        }
    }
</script>

<style scoped>

</style>